import { render, staticRenderFns } from "./IconDots.vue?vue&type=template&id=dff36196"
import script from "./IconDots.vue?vue&type=script&lang=js"
export * from "./IconDots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports